import React from 'react';
import { FloatingPortal } from '@floating-ui/react';
const POPOVER_PORTAL_NAME = 'vulcanui-popover-portal';
function PopoverPortal({ children }) {
    return React.createElement(FloatingPortal, null, children);
}
PopoverPortal.displayName = 'Popover.Portal';
PopoverPortal.toString = () => `.${POPOVER_PORTAL_NAME}`;
export default PopoverPortal;
//# sourceMappingURL=popover-portal.js.map